import Section from "./Section";
import TopLevelFields from "./TopLevelFields";


const QuestionnaireField = ({
    questionaire,
    topLevelFields,
    allFields,
    setFieldIndex,
    fieldIndex,
    compagnyId,
    languageCode,
    settings,
    moment,
    persona,
    questionnaireId,
    research,
    sessionId,
    hiddenFieldIDs
}) => {

    return (
        <div id='questionnaire-fields-container'
        >
            {topLevelFields &&
                topLevelFields.map((field, index) => (
                    <div key={field.ID} id='questionnaire-field-section-item-container'>
                        {field.Type === 'section' && (
                            <Section
                                field={field}
                                index={index}
                                setFieldIndex={setFieldIndex}
                                fieldIndex={fieldIndex}
                                compagnyId={compagnyId}
                                questionaire={questionaire}
                                languageCode={languageCode}
                                topLevelFields={topLevelFields}
                                allFields={allFields}
                                moment={moment}
                                persona={persona}
                                questionnaireId={questionnaireId}
                                research={research}
                                sessionId={sessionId}
                                hiddenFieldIDs={hiddenFieldIDs}
                            />
                        )}
                        {field.Type !== 'section' && (
                            <TopLevelFields
                                field={field}
                                index={index}
                                setFieldIndex={setFieldIndex}
                                fieldIndex={fieldIndex}
                                compagnyId={compagnyId}
                                questionaire={questionaire}
                                languageCode={languageCode}
                                topLevelFields={topLevelFields}
                                settings={settings}
                                moment={moment}
                                persona={persona}
                                questionnaireId={questionnaireId}
                                research={research}
                                sessionId={sessionId}
                                hiddenFieldIDs={hiddenFieldIDs}
                            />
                        )}
                    </div>
                ))}
        </div>
    );
};

export default QuestionnaireField;
